import { useContext, useEffect, useState } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import defaultZone from "../../assets/img/icon/GPS/location.png";
import selectZone from "../../assets/img/icon/GPS/selectLocation.svg";
import greenZone from "../../assets/img/icon/GPS/location_green.svg";
import api from "../../api";
import ReaderSelector from "./ReaderSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartbeat } from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import DeviceDetail from "../../components/deviceInfo/DeviceDetail";
import useAuth from "../../hooks/useAuth";
import NotyfContext from "../../contexts/NotyfContext";
import { Layers, Wifi } from "react-feather";
import CommonMap from "../../components/maps/CommonMap";
import { withCommonMapProvider } from "../../utils/withCommonMapProvider";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useMap,
  MapControl,
  ControlPosition,
} from "@vis.gl/react-google-maps";
import useCommonMap from "../../hooks/useCommonMap";

let source1 = null;
const UserReaderMap = () => {
  const [showReader] = useState(false);
  const [showSearch] = useState(true);
  const [reader, setReader] = useState(null);
  const [readers, setReaders] = useState([]);
  const [showEditModal, setShowEdit] = useState(null);
  const [name, setName] = useState(null);
  const [wirepas, setWirepas] = useState(false);
  // const [hasFloorPlan, setHasFloorPlan] = useState(true);
  // const [noResultText, setNoResultText] = useState(null);
  const notify = useContext(NotyfContext);
  const { user } = useAuth();
  const [hideOtherFloors, setHideOtherFloors] = useState(false);

  const map = useMap();
  const commonMap = useCommonMap();
  const {
    selectedFloorplan,
    // setSelectedFloorplan,
    // floorplanImage,
    // setFloorplanImage,
  } = commonMap;

  const onSave = () => {
    let obj = JSON.parse(JSON.stringify(showEditModal));
    obj.deviceName = name;
    obj.wirepas = wirepas;
    api.put(`readers`, obj).then((res) => {
      notify.open({
        type: "success",
        message: "Changes Saved",
      });
      setShowEdit(null);
      setReader(res.data);
      setReaders((pre) => {
        let arr = pre.concat([]);
        let filter = arr.filter((item) => item.id === res.data.id);
        if (filter.length > 0) {
          filter[0].deviceName = res.data.deviceName;
          filter[0].wirepas = res.data.wirepas;
        }
        return arr;
      });
    });
  };

  useEffect(() => {
    return () => {
      if (source1) {
        source1.cancel("request canceled");
      }
    };
  }, []);

  const onSelectReader = (data) => {
    setReader(data);
    // console.log("%s", JSON.stringify(data));
    map.setCenter({ lat: Number(data.latitude), lng: Number(data.longitude) });
  };

  // const cancelOption = () => {
  //   setShowReader((prevState) => {
  //     return !prevState;
  //   });
  // };

  const getZoneIcon = (item) => {
    if (item.id === reader?.id) return selectZone;
    if (item.wirepas) return greenZone;
    return defaultZone;
  };

  return (
    <div>
      <div>
        <div style={{ width: "100%" }} className="position-relative">
          {reader && (
            <Card className="mb-0 border-bottom">
              <Card.Body className="d-flex align-items-center ">
                <Wifi className="me-2" size={14} />
                <span
                  onClick={() => {
                    setName(reader.deviceName);
                    setWirepas(reader.wirepas);
                    setShowEdit(reader);
                  }}
                  className="text-primary cursor-pointer"
                >
                  {reader.serial}
                  {reader.deviceName && (
                    <>
                      <span>&nbsp;({reader.deviceName})</span>
                    </>
                  )}
                </span>
                {reader.lastReport && (
                  <div className="ms-2">
                    <Layers className="me-2" size={14} />
                    <span className="me-2">{reader?.model}</span>
                    <FontAwesomeIcon
                      className="me-2"
                      icon={faHeartbeat}
                      size={"sm"}
                    />
                    <span className="me-2">
                      {moment(reader.lastReport).format("DD/MM/YYYY HH:mm:ss")}
                    </span>
                    {/* {reader.deviceName && <><FontAwesomeIcon className="me-2" icon={faSignature} size={"sm"} />
                  <span className="me-2">{reader.deviceName}</span></>} */}
                  </div>
                )}
                {(!reader.latitude || !reader.longitude) && (
                  <div className="ms-2">
                    <span className="ms-2 text-danger">Not Yet Configured</span>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          <CommonMap
            height="calc(100vh - 280px)"
            type={"editReaders"}
            showMapDetail={false}
            showNearByAssets={false}
            showNearByZones={false}
            showAllLabels={false}
            showHashTagFilter={false}
            showCategoryFilter={false}
            floorplanMode={"readerview"}
          >
            <div className={!showSearch ? "visually-hidden" : ""}>
              <ReaderSelector
                showMap
                reader={reader}
                getAllReaders={(e) => setReaders(e)}
                onSelect={onSelectReader}
                showDefault
                showReader={showReader}
              />
            </div>

            <MapControl position={ControlPosition.TOP_LEFT}>
              <div
                // className="d-flex justify-content-between align-items-center px-0"
                className="d-flex align-items-center px-0"
                style={{
                  background: "#ffffffff",
                  margin: "10px",
                  width: "160px",
                  height: "40px",
                  borderRadius: "2px",
                }}
                alt=""
              >
                <input
                  type="checkbox"
                  id="hide-01"
                  checked={hideOtherFloors}
                  className="align-middle"
                  onChange={(e) => {
                    setHideOtherFloors(e.target.checked);
                  }}
                />
                <label
                  className="px-1 m-0 align-top text-light"
                  aria-details="kdkd"
                  htmlFor="hide-01"
                >
                  Hide Other Floors
                </label>
              </div>
            </MapControl>

            {map &&
              readers.map((item) => {
                return (
                  <GeoMarker
                    key={item.id}
                    onSelect={() => setReader(item)}
                    item={item}
                    lat={item.latitude}
                    lng={item.longitude}
                    selected={item.id === reader?.id}
                    defaultZone={getZoneIcon(item)}
                    curFloor={selectedFloorplan}
                    hideOtherFloors={hideOtherFloors}
                  />
                );
              })}
          </CommonMap>
        </div>
      </div>
      <Modal show={showEditModal} onHide={() => setShowEdit(null)}>
        <Modal.Header closeButton>
          <Modal.Title>{showEditModal?.serial}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeviceDetail
            onChangeName={(e) => setName(e)}
            onChangeWirepas={(e) => setWirepas(e)}
            data={showEditModal}
            type="readers"
          />
        </Modal.Body>
        <Modal.Footer>
          {user?.editReaders && <Button onClick={() => onSave()}>Save</Button>}
          <Button onClick={() => setShowEdit(false)} variant={"secondary"}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

// const getBackground = (item, defaultZone) => {
//   if (defaultZone) return "bg-primary";
//   if (item.wirepas) return "bg-success";
//   return "bg-danger";
// };

const GeoMarker = ({
  lat,
  lng,
  defaultZone,
  onSelect,
  item,
  selected,
  curFloor,
  hideOtherFloors,
}) => {
  const sameAltitude =
    (curFloor?.altitude ?? 0) === (item.altitude ?? 0) ||
    (curFloor?.altitude ?? 0) === -1;

  if (!sameAltitude && hideOtherFloors) return null;

  // return (
  //   <AdvancedMarker position={{ lat: Number(lat), lng: Number(lng) }}>
  //     <div
  //       style={{
  //         marginLeft: "-15px",
  //         marginTop: "-15px",
  //         opacity: sameAltitude ? "100%" : "33%",
  //       }}
  //     >
  //       <img
  //         alt="marker"
  //         onClick={() => onSelect()}
  //         style={{ height: "30px", width: "30px", cursor: "pointer" }}
  //         src={defaultZone}
  //       />
  //       <div
  //         className={`text-black position-absolute marker-position-bottom ps-1 pe-1 radius-3 text-nowrap font-weight-bold ${getBackground(
  //           item,
  //           selected
  //         )}`}
  //         style={{ fontSize: "14px", transform: "translate(-50%, 50%)" }}
  //       >
  //         {item?.serial}-9230839013890
  //       </div>
  //     </div>
  //   </AdvancedMarker>
  // );

  return (
    <AdvancedMarker
      position={{
        lat: Number(lat),
        lng: Number(lng),
      }}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      clickable
      onClick={() => {
        onSelect(item);
      }}
    >
      <img src={defaultZone} width={"30px"} alt="Marker" />
      <div
        className="px-1 text-nowrap text-black bg-primary bg-opacity-75 rounded"
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: 4,
          pointerEvents: "none",
        }}
      >
        {item?.serial}
      </div>
    </AdvancedMarker>
  );
};

export default withCommonMapProvider(UserReaderMap);
